import MERNCertificate from '../../img/MERNCourseImage.jfif';
import javascriptCertification from '../../img/JavaScriptCertificate.jpg';
import HackerCertificate from '../../img/hackerRankCertificate.png';
import { Grid, useTheme, useMediaQuery } from "@mui/material";
import ProjectCertificateCards from '../shared/projectsCertificatesCard';

const AllCertificatesFetches = () => {

    const themeHook = useTheme();
  const isSmallScreen = useMediaQuery(themeHook.breakpoints.down("md"));

    const certificates = [
        {
            img: MERNCertificate,
            review: "MERN Fullstack Guide - Udemy",
          },
        {
          img: javascriptCertification,
          review: "Complete JavaScript Course - Udemy",
        },
        {
          img: HackerCertificate,
          review: "Hacker Rank - SQL",
        }
      ];

    return (
        <Grid
      container
      sx={{
        m: isSmallScreen ? 0 : 4,
        mb: isSmallScreen && 8,
        ml: !isSmallScreen && 7,
      }}
    >
      {certificates.map((elem, index) => (
        <Grid item xs={12} md={4} key={index}>
          <ProjectCertificateCards
            image={elem.img}
            heading={elem.review}
            certificate={true}
          />
        </Grid>
      ))}
    </Grid>
    )
}

export default AllCertificatesFetches;